function asElementProps(source) {
  const media = source.media;
  const type = source.type;
  const sizes = source.sizes?.map(x => `${x.media || ''} ${x.width}`.trim()).join(', ');
  const srcSet = source.srcSet.map(x => `${x.src} ${x.size || ''}`.trim()).join(', ');
  return {
    media,
    type,
    sizes,
    srcSet
  };
}

export { asElementProps };
